import { componentState } from "../../../atoms/componentState";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Flex } from "@chakra-ui/react";
import { PRIMARY } from "../../../constants/colors";
import { FaCalculator, FaCalendar } from "react-icons/fa";
import BoxCardsMenus from "../../../defaultComponents/boxCardsMenus";
import CardMenu from "../../../defaultComponents/cardsMenu";
import {
  LISTAGEMPLANOS,
  LISTAGEMVENDASRECORRENTES,
} from "../../../constants/paths";
import { customColors } from "../../../atoms/customColors";

export default function VendasRecorrentes() {
  const setHeaderLocation = useSetRecoilState(componentState);
  setHeaderLocation("Vendas Recorrentes");

  const colors = useRecoilState(customColors)[0];

  return (
    <Flex flexDir={"column"} height="85vh" width="100%" overflowY={"scroll"}>
      <BoxCardsMenus color={colors.BLUEMONEDDBUTTONS} text={"Opções"}>
        {/* <CardMenu
          icon={<FaUserCircle />}
          text={"Listagem de Compradores"}
          path={LISTAGEMCOMPRADORES}
          color={PRIMARY}
          description="Gerencie os compradores"
        /> */}
        <CardMenu
          icon={<FaCalculator />}
          text={"Planos de Assinatura"}
          path={LISTAGEMPLANOS}
          color={colors.BLUEMONEDDBUTTONS}
          description="Gerencie os planos para assinaturas"
        />
        <CardMenu
          icon={<FaCalendar />}
          text={"Assinaturas"}
          path={LISTAGEMVENDASRECORRENTES}
          color={colors.BLUEMONEDDBUTTONS}
          description="Gerencie as assinaturas"
        />
      </BoxCardsMenus>
    </Flex>
  );
}
